var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ib-wait-spin" }, [
    _vm._m(0),
    _c(
      "p",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.label,
            expression: "label"
          }
        ],
        staticClass: "fg70"
      },
      [_vm._v(_vm._s(_vm.label))]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spin-wrapper bg" }, [
      _c("div", { staticClass: "spin-content" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }